import { render } from "./presenters.vue?vue&type=template&id=4567ba98&scoped=true"
import script from "./presenters.vue?vue&type=script&lang=js"
export * from "./presenters.vue?vue&type=script&lang=js"

import "./presenters.vue?vue&type=style&index=0&id=4567ba98&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4567ba98"

export default script